import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Carousel, Modal, message } from 'antd';
import { DDLoading } from '../../globalPageStatus';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import Scrollbar from 'react-scrollbars-custom';
import { cloneDeep } from 'lodash-es';

const AtlasDetailsModal = ({ cRef, ds, list }) => {
  const carouselElement = useRef();
  const [visible, setVisible] = useState(false); // 是否显示弹窗
  const [loading, setLoading] = useState(false); // 是否显示loading
  const [carCurIndex, setCarCurIndex] = useState(null); // 轮播图当前索引
  const [giftsDetail, setGiftsDetail] = useState({}); // 礼物详情

  useImperativeHandle(cRef, () => ({
    showModal: (index = 0) => {
      setTimeout(() => {
        if (carouselElement.current) {
          carouselElement.current.goTo(index, true);
        }
      }, 100);

      setCarCurIndex(index);
      setVisible(true);
    },
  }));

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (carCurIndex != null) {
      const curGift = list[carCurIndex];
      if (curGift) {
        getUserGiftDetail(curGift);
      }
    }
  }, [carCurIndex]);

  // 礼物详情
  const getUserGiftDetail = (gift) => {
    if (!giftsDetail[gift.giftId]) {
      const giftsDetailCopy = cloneDeep(giftsDetail);
      setLoading(true);
      HTTP._get_user_gift_detail({ searchUid: ds.uid, giftId: gift.giftId })
        .then((res) => {
          if (res?.code === 200) {
            giftsDetailCopy[gift.giftId] = res.data;
            setGiftsDetail(giftsDetailCopy);
          } else {
            message.warning(res?.message || '获取详情失败，请稍后重试');
            hideModal();
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // 隐藏弹窗
  const hideModal = () => {
    setVisible(false);
    setCarCurIndex(null);
    setGiftsDetail({});
  };

  // 轮播图切换
  const onChangeCarousel = (type) => {
    if (carouselElement.current) {
      if (type === -1) {
        if (carCurIndex > 0) {
          setCarCurIndex(carCurIndex - 1);
          carouselElement.current.prev();
        }
      } else {
        if (carCurIndex < list.length - 1) {
          setCarCurIndex(carCurIndex + 1);
          carouselElement.current.next();
        }
      }
    }
  };

  return (
    <Modal
      open={visible}
      title={null}
      wrapClassName="atlas-details-modal"
      footer={null}
      closable={false}
      centered
      maskClosable={false}
    >
      <DDLoading status={loading}>
        <div className="carousel-wrap">
          <div className="carousel-prev" onClick={() => onChangeCarousel(-1)} />
          <div className="carousel-center">
            {!!list?.length && (
              <Carousel ref={carouselElement} dots={false}>
                {list.map((item, index) => {
                  const _item = giftsDetail?.[item.giftId] || null;
                  return (
                    <div
                      key={item.giftId}
                      className={Util.classNames('carousel-item', {
                        'is-custom-bg': _item?.backImg,
                      })}
                    >
                      {_item && (
                        <>
                          {_item?.backImg && (
                            <div
                              className="carousel-item-bg"
                              style={{
                                backgroundImage: `url(${Util.transImgUrl(_item.backImg, '282x397')})`,
                              }}
                            />
                          )}
                          <div
                            className={Util.classNames('gift-cover', {
                              'is-light-status': !_item?.lightStatus,
                            })}
                          >
                            <img
                              src={Util.transImgUrl(_item.staticPic, '200x200')}
                              alt={_item.giftName}
                            />
                          </div>
                          <div className="line-tag">
                            <span className="num">
                              {_item?.lightStatus
                                ? `x${_item.giftNum}`
                                : '未点亮'}
                            </span>
                            {_item.rarityImg && (
                              <span
                                className="tag"
                                style={{
                                  backgroundImage: `url(${Util.transImgUrl(_item.rarityImg, '45x18')})`,
                                }}
                              />
                            )}
                          </div>
                          <div className="footer">
                            <Scrollbar>
                              <p className="line">
                                <label>礼物价值:</label>
                                <span className="diamond">
                                  {Util.numberFormat(_item.saleAmount)}
                                </span>
                              </p>
                              <p className="line">
                                <label>点亮时间:</label>
                                <span className="text">
                                  {_item?.lightStatus
                                    ? _item?.lightTime || '00:00'
                                    : '-'}
                                </span>
                              </p>
                              <p className="line">
                                <label>图鉴来源:</label>
                                <span className="text">
                                  {_item?.giftSource || '-'}
                                </span>
                              </p>
                            </Scrollbar>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </Carousel>
            )}
          </div>
          <div className="carousel-next" onClick={() => onChangeCarousel(1)} />
        </div>
      </DDLoading>
      <div className="icon-close" onClick={hideModal} />
    </Modal>
  );
};

export default AtlasDetailsModal;
